module.exports = __webpack_public_path__ + "img/emoji-wolf-240x240.5031f67a.png";